module.exports = __webpack_public_path__ + "img/test-drive-country_side.cefc5e28.svg";